import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { ConfigService } from '@services/webFeeder/config.service';

@Injectable({ providedIn: 'root' })
export class RankingViewGuard  {

  constructor(
    private _router: Router,
    private _config: ConfigService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const whiteLabel = this._config.getWhiteLabel();
    if (whiteLabel === WhitelabelEnum.RANKING) {
      return true;
    } else {
      this._router.navigate(['/error'], { queryParams: { type: 'unauthorized' } });
    }
  }

}
